/* You can add your custom scripts here */

// Image cards carousel ("Shop the look"): keep the arrows in the middle of the
// photo frames. The theme works this out from the first photo's own shape,
// which is wrong once the cards use a fixed shape such as 4:5.
document.querySelectorAll('.section-image-cards-carousel-cards.has-carousel').forEach((carousel) => {
  const frame = carousel.querySelector('.section-image-cards-carousel-card__image');
  if (!frame || !('ResizeObserver' in window)) return;

  new ResizeObserver(() => {
    const middle = frame.getBoundingClientRect().top - carousel.getBoundingClientRect().top + frame.offsetHeight / 2;
    carousel.style.setProperty('--ono-card-image-middle', `${Math.round(middle)}px`);
  }).observe(frame);
});
